// Utils
import renderComponent from '../../utils/renderComponent'

// Context
import { useLayoutContext } from '../../../../../../../contexts/LayoutContext'

// Styles
import style from './style.module.css'

const LayoutItem = ({
  handleDragStart,
  handleDragOver,
  handleDrop,
  handleDragEnd,
  draggingIndex,
  dragOverIndex,
  index,
  userProfile,
  item,
  editMode,
  toggleModal,
  openModal,
}) => {
  const { layout, setLayout, saveLayout } = useLayoutContext()

  const handleDoubleClick = (index) => {
    const updatedComponents = [...layout]
    updatedComponents[index].type = 'full'
    setLayout(updatedComponents)
    saveLayout(updatedComponents, userProfile.user.user_id)
  }

  const removeComponent = (id) => {
    const userId = userProfile.user.user_id
    const updatedLayout = layout.filter((item) => item.id !== id)
    setLayout(updatedLayout)
    saveLayout(updatedLayout, userId)
  }

  return (
    <div
      onDragStart={() => handleDragStart(index)}
      onDragOver={(e) => {
        e.preventDefault()
        handleDragOver(index)
      }}
      onDrop={() => handleDrop(index)}
      onDragEnd={handleDragEnd}
      onDoubleClick={() => handleDoubleClick(index)}
      className={`${style.gridItem} ${editMode && style.gridItem_editMode} ${
        dragOverIndex === index ? style.shrink : ''
      } ${draggingIndex === index ? style.expand : ''}`}
    >
      {editMode && item.type !== 'half' && (
        <span
          className={`${style.addComponentButton} ${style.addComponentButton_vertical}`}
        >
          +
        </span>
      )}

      {renderComponent({
        id: item.id,
        userProfile,
        editMode,
        toggleModal,
        openModal,
        removeComponent,
      })}

      {editMode && item.type !== 'half' && (
        <span
          className={`${style.addComponentButton} ${style.addComponentButton_vertical}`}
        >
          +
        </span>
      )}
    </div>
  )
}

export default LayoutItem
